// Central category color configuration
// Single source of truth for all category colors across the application

export const CATEGORY_COLORS = {
  // Bakery & Bread
  'Panes': '#f7b733',
  'Pan': '#f7b733',
  'Panadería': '#f7b733',
  'Panaderia': '#f7b733',

  // Pastries & Sweets
  'Facturas': '#f7971e',
  'Dulces': '#f953c6',
  'Postres': '#f953c6',
  'Bolleria': '#fa709a',
  'Alfajores': '#fa709a',
  'Havanna': '#764ba2',
  'Porciones': '#fe5196',

  // Savory Items
  'Salados': '#ee0979',
  'Bocadillos': '#ee0979',
  'Comida Rápida': '#ee0979',
  'Sandwiches': '#ee0979',
  'Masas Saladas': '#c0392b',

  // Special Categories
  'Aptos': '#43e97b',
  'Multi-Aptos': '#43e97b',
  'GlutenFree': '#43e97b',

  // Cold Storage
  'Heladera': '#4facfe',
  'Lácteos': '#4facfe',
  'Congelados': '#00c6ff',
  'Viandas': '#00c6ff',

  // Beverages & Infusions
  'Infusiones': '#38f9d7',
  'Café': '#38f9d7',
  'Bebidas': '#00b4d8',

  // Storage & Gifts
  'Almacen': '#667eea',
  'Almacén': '#667eea',
  'Regalos': '#a855f7',
  'Promociones': '#a855f7',

  // Specialty Items
  'Carnes': '#f77062',
  'Verduras': '#56ab2f',
  'Especiales': '#a855f7',

  // Additional categories from backend
  'Tortas Especiales': '#f953c6',
  'Tortas Diarias': '#fe5196',
  'Comida': '#56ab2f',
  'Cotillón': '#a855f7'
};

// Helper function to get category color with fallback
export const getCategoryColor = (categoryName) => {
  return CATEGORY_COLORS[categoryName] || '#95a5a6'; // Default gray if category not found
};

// Export category mappings with icons for backward compatibility
export const CATEGORY_MAPPINGS = {
  'Panes': { icon: 'Wheat', color: CATEGORY_COLORS['Panes'] },
  'Pan': { icon: 'Wheat', color: CATEGORY_COLORS['Pan'] },
  'Panadería': { icon: 'Wheat', color: CATEGORY_COLORS['Panadería'] },
  'Panaderia': { icon: 'Wheat', color: CATEGORY_COLORS['Panaderia'] },
  'Facturas': { icon: 'Croissant', color: CATEGORY_COLORS['Facturas'] },
  'Dulces': { icon: 'Dessert', color: CATEGORY_COLORS['Dulces'] },
  'Postres': { icon: 'Dessert', color: CATEGORY_COLORS['Postres'] },
  'Alfajores': { icon: 'CircleStar', color: CATEGORY_COLORS['Alfajores'] },
  'Havanna': { icon: 'CircleStar', color: CATEGORY_COLORS['Havanna'] },
  'Porciones': { icon: 'CakeSlice', color: CATEGORY_COLORS['Porciones'] },
  'Salados': { icon: 'Sandwich', color: CATEGORY_COLORS['Salados'] },
  'Bocadillos': { icon: 'Sandwich', color: CATEGORY_COLORS['Bocadillos'] },
  'Comida Rápida': { icon: 'Sandwich', color: CATEGORY_COLORS['Comida Rápida'] },
  'Aptos': { icon: 'Multi-Aptos', color: CATEGORY_COLORS['Aptos'] },
  'GlutenFree': { icon: 'Multi-Aptos', color: CATEGORY_COLORS['GlutenFree'] },
  'Heladera': { icon: 'Refrigerator', color: CATEGORY_COLORS['Heladera'] },
  'Lácteos': { icon: 'Refrigerator', color: CATEGORY_COLORS['Lácteos'] },
  'Congelados': { icon: 'Snowflake', color: CATEGORY_COLORS['Congelados'] },
  'Viandas': { icon: 'Snowflake', color: CATEGORY_COLORS['Viandas'] },
  'Infusiones': { icon: 'LeafyGreen', color: CATEGORY_COLORS['Infusiones'] },
  'Café': { icon: 'LeafyGreen', color: CATEGORY_COLORS['Café'] },
  'Almacen': { icon: 'ShoppingBasket', color: CATEGORY_COLORS['Almacen'] },
  'Almacén': { icon: 'ShoppingBasket', color: CATEGORY_COLORS['Almacén'] },
  'Regalos': { icon: 'Gift', color: CATEGORY_COLORS['Regalos'] },
  'Promociones': { icon: 'Gift', color: CATEGORY_COLORS['Promociones'] },
  'Bebidas': { icon: 'Refrigerator', color: CATEGORY_COLORS['Bebidas'] },
  'Carnes': { icon: 'Sandwich', color: CATEGORY_COLORS['Carnes'] },
  'Verduras': { icon: 'LeafyGreen', color: CATEGORY_COLORS['Verduras'] }
};